module.exports = __webpack_public_path__ + "img/01-hole-light.e4b3fb88.png";